import { Location } from 'react-router-dom'

export const createRelativePath = (location: Location, limit?: number) => {
  const currentPath = location.pathname.split('/', limit)
  currentPath.pop()
  return currentPath.join('/') + '/'
}
